var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.summary.filter(function (ref) {
	var _ = ref[0];
	var v = ref[1];

	return v;
})),function(ref){
var k = ref[0];
var v = ref[1];
return _c('div',{key:k,staticClass:"py-1"},[_c('div',{staticClass:"text-xs font-bold"},[_vm._v(_vm._s(k))]),_c('div',{staticClass:"text-sm text-gray-500"},[_vm._v(_vm._s(v))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }